import { wordService } from "../services/wordService";

export const applyMinorSection = () =>
  wordService.applySemanticTag({ type: "section", styleBuiltIn: "Heading3", metadata: { level: 3 } });
